import PropTypes from 'prop-types';
var optionsPropTypes = {
  appearance: PropTypes.oneOf(['categories', 'highlight', 'feedback']),
  chart: PropTypes.shape({}),
  drilldown: PropTypes.shape({}),
  highlightIndex: PropTypes.number,
  intermediaryIndex: PropTypes.number,
  legend: PropTypes.shape({}),
  negativeIndex: PropTypes.number,
  numberOfColors: PropTypes.number,
  plotOptions: PropTypes.shape({}),
  positiveIndex: PropTypes.number,
  series: PropTypes.arrayOf(PropTypes.any.isRequired),
  title: PropTypes.shape({}),
  xAxis: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  yAxis: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
var propTypes = {
  options: PropTypes.shape(optionsPropTypes).isRequired,
  type: PropTypes.oneOf(['chart', 'mapChart'])
};
export default propTypes;